import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/promocodes-adm`, {params})
    },
    listCodes(params) {
        return Vue.axios.get(`/promocodes/codes`, {params})
    },
    create(params) {
        return Vue.axios.post(`/promocodes/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/promocodes/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/promocodes/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/promocodes/${id}`)
    },
    listByUser(id) {
        return Vue.axios.get(`/promocodes/by-user-adm/${id}`)
    },
    listByPromo(id, params = {}) {
        return Vue.axios.get(`/promocodes/orders/${id}`, {params})
    },
    updateProducts(params) {
        return Vue.axios.post(`/promocodes/update/products`, params)
    },
    removeProduct(id) {
        return Vue.axios.get(`/promocodes/remove/products/${id}`)
    },
    showBlocked(id) {
        return Vue.axios.get(`/promocodes/blocked/${id}`)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
